const {
  BASE_URL,
  VITE_BASE_API_URL,
  VITE_FAST_API_URL,
  VITE_MATTER_STREAM_URL,
  VITE_NOTIFICATION_STREAM_URL,
  VITE_API_STAGE,
  VITE_AWS_USER_POOL_ID,
  VITE_AWS_USER_POOL_CLIENT_ID,
  VITE_GOOGLE_MAPS_API_KEY,
  VITE_APRYSE_LICENSE_KEY,
} = import.meta.env;

export {
  BASE_URL,
  VITE_API_STAGE,
  VITE_AWS_USER_POOL_CLIENT_ID,
  VITE_AWS_USER_POOL_ID,
  VITE_BASE_API_URL,
  VITE_FAST_API_URL,
  VITE_MATTER_STREAM_URL,
  VITE_NOTIFICATION_STREAM_URL,
  VITE_GOOGLE_MAPS_API_KEY,
  VITE_APRYSE_LICENSE_KEY,
};
